const Modes = {
    DRIVER_DASHBOARD: 'driverDashboard',
    DISPATCHER: 'dispatcher',
    ORDER_READY: 'orderReady',
}

export default Modes;